import { render, staticRenderFns } from "./CreateGroup.vue?vue&type=template&id=36993fdd&scoped=true"
import script from "./CreateGroup.vue?vue&type=script&lang=js"
export * from "./CreateGroup.vue?vue&type=script&lang=js"
import style0 from "./CreateGroup.vue?vue&type=style&index=0&id=36993fdd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36993fdd",
  null
  
)

export default component.exports